import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, makeStyles, createStyles, useMediaQuery, Drawer, useTheme, } from "@material-ui/core";
import clsx from "clsx";
import FTLIconButton from "../buttons/FTLIconButton";
import FTLTypography from "./FTLTypography";
import CloseIcon from "../icons/Close";
import FTLButton from "../buttons/FTLButton";
export default ({ open = false, onClose = () => { }, onCancel, onSubmit, title = "Внимание", submitText = "Подтвердить", cancelText = "Отмена", children, showActions = true, classes, size = "small", style, }) => {
    const basicClasses = useStyles({ size });
    const mobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
    const components = (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, { disableTypography: true, className: clsx(basicClasses.title, classes === null || classes === void 0 ? void 0 : classes.title) },
            typeof title === "string" ? (React.createElement(FTLTypography, { variant: "h2" }, title)) : (title),
            onClose && (React.createElement(FTLIconButton, { "aria-label": "close", onClick: (e) => onClose(e, "backdropClick"), className: clsx(basicClasses.closeButton, classes === null || classes === void 0 ? void 0 : classes.closeButton) },
                React.createElement(CloseIcon, null)))),
        React.createElement(DialogContent, { className: clsx(basicClasses.content, classes === null || classes === void 0 ? void 0 : classes.content) }, children),
        showActions && (onCancel || onSubmit) && (React.createElement(DialogActions, { className: clsx(basicClasses.actions, classes === null || classes === void 0 ? void 0 : classes.actions) },
            onCancel && (React.createElement(FTLButton, { variant: "text", onClick: onCancel }, cancelText)),
            onSubmit && (React.createElement(FTLButton, { color: "primary", onClick: onSubmit }, submitText))))));
    const theme = useTheme();
    return mobile ? (React.createElement(Drawer, { anchor: "bottom", open: open, onClose: (e) => onClose(e, "backdropClick"), style: size === "small" ? Object.assign(Object.assign({}, style), { zIndex: theme.zIndex.appBar }) : style, classes: {
            paper: basicClasses.paper,
        }, disableEnforceFocus: true, elevation: 0 }, components)) : (React.createElement(Dialog, { open: open, onClose: onClose, classes: {
            paper: basicClasses.paper,
        }, style: size === "large" ? Object.assign(Object.assign({}, style), { zIndex: theme.zIndex.appBar }) : style }, components));
};
const useStyles = makeStyles((theme) => createStyles({
    paper: ({ size }) => ({
        width: "100%",
        maxWidth: size === "large" ? 1000 : 320,
        height: size === "large" ? 612 : "auto",
        [theme.breakpoints.down("sm")]: {
            position: "absolute",
            bottom: 0,
            margin: 0,
            borderRadius: 0,
            width: "100%",
            maxWidth: "none",
            maxHeight: "calc(100% - 56px)",
            height: size === "large" ? "100%" : "auto",
        },
    }),
    content: ({ size }) => (Object.assign(Object.assign({ padding: size === "large" ? "0 40px" : "0px 24px 24px 24px", overflowX: "hidden" }, theme.typography.p3), { [theme.breakpoints.down("sm")]: {
            width: "auto",
            height: "auto",
            padding: `0px ${theme.spacing(4)}px ${theme.spacing(6)}px ${theme.spacing(4)}px`,
        } })),
    title: ({ size }) => ({
        height: size === "large" ? 56 : "auto",
        padding: size === "large" ? "14px 40px" : "24px 24px 16px 24px",
        [theme.breakpoints.down("sm")]: {
            padding: `${theme.spacing(4)}px ${theme.spacing(4)}px ${theme.spacing(6)}px ${theme.spacing(4)}px`,
        },
    }),
    actions: ({ size }) => ({
        padding: size === "large" ? "0 40px 24px 40px" : "0 24px 24px 24px",
        [theme.breakpoints.down("sm")]: {
            padding: `0 ${theme.spacing(4)}px ${theme.spacing(4)}px`,
        },
    }),
    closeButton: {
        position: "absolute",
        right: 16,
        top: 12,
        width: 32,
        height: 32,
        [theme.breakpoints.down("sm")]: {
            top: theme.spacing(4),
            right: theme.spacing(3),
        },
    },
}));
//# sourceMappingURL=FTLDialog.js.map